import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";


const TELECALLER_BUCKETWISE_ALLOCATION_API = "telecaller/bucket-wise-allocation";
const TELECALLER_BUCKETWISE_STATUS_API = "telecaller/bucket-status";
const TELECALLER_BANK_TEAMLEAD_OVERVIEW = "telecaller/overview-bar";
const TELECALLER_BANK_STATS = "telecaller/overview-stats";


export const fetchTelecallerBucketWiseAllocation = createAsyncThunk(
    "bankDetails/fetchTelecallerBucketWiseAllocation",
    async (params, thunkAPI) => {
        try {
            const state = thunkAPI.getState();
            const token = state.auth.token;
            const validUser = state.auth.user;
            if (!token || !validUser?.is_tc) {
                return;
            }

            const response = await axios.get(`${TELECALLER_BUCKETWISE_ALLOCATION_API}/${params?.portfolio_id}/`, {
                // params,
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                },
            });

            return response?.data?.data;
        } catch (error) {
            return thunkAPI.rejectWithValue(
                error.response?.data?.message ||
                error.message ||
                "Failed to fetch users list"
            );
        }
    }
);
export const fetchTelecallerBucketWiseStatus = createAsyncThunk(
    "bankDetails/fetchTelecallerBucketWiseStatus",
    async (params, thunkAPI) => {
        try {
            const state = thunkAPI.getState();
            const token = state.auth.token;
            const validUser = state.auth.user;
            if (!token || !validUser?.is_tc) {
                return;
            }


            const response = await axios.get(`${TELECALLER_BUCKETWISE_STATUS_API}/${params?.portfolio_id}/`, {
                // params,
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                },
            });

            return response?.data?.data;
        } catch (error) {
            return thunkAPI.rejectWithValue(
                error.response?.data?.message ||
                error.message ||
                "Failed to fetch users list"
            );
        }
    }
);
export const fetchTelecallerBankTeamleadOverview = createAsyncThunk(
    "bankDetails/fetchTelecallerBankTeamleadOverview",
    async (params, thunkAPI) => {
        try {
            const state = thunkAPI.getState();
            const token = state.auth.token;
            const validUser = state.auth.user;
            if (!token || !validUser?.is_tc) {
                return;
            }


            const response = await axios.get(`${TELECALLER_BANK_TEAMLEAD_OVERVIEW}/${params?.portfolio_id}/`, {
                // params,
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                },
            });

            return response?.data?.data;
        } catch (error) {
            return thunkAPI.rejectWithValue(
                error.response?.data?.message ||
                error.message ||
                "Failed to fetch users list"
            );
        }
    }
);
export const fetchTelecallerBankreportStats = createAsyncThunk(
    "bankDetails/fetchTelecallerBankreportStats",
    async (params, thunkAPI) => {
        try {
            const state = thunkAPI.getState();
            const token = state.auth.token;
            const validUser = state.auth.user;
            if (!token || !validUser?.is_tc) {
                return;
            }


            const response = await axios.get(`${TELECALLER_BANK_STATS}/${params?.portfolio_id}/`, {
                // params,
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                },
            });

            return response?.data?.data;
        } catch (error) {
            return thunkAPI.rejectWithValue(
                error.response?.data?.message ||
                error.message ||
                "Failed to fetch users list"
            );
        }
    }
);



const initialState = {
    telecaller_bucketwise_allocation: {},
    telecaller_bucketwise_allocation_loading: false,

    telecaller_bucketwise_status: {},
    telecaller_bucketwise_status_loading: false,

    telecaller_bank_teamlead_overview: {},
    telecaller_bank_teamlead_overview_loading: false,

    telecaller_bankreport_stats: {},
    telecaller_bankreport_stats_loading: false,


};
const telecallerBankDashboard = createSlice({
    name: "telecallerBankDashboard",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchTelecallerBucketWiseAllocation.pending, (state) => {
                state.telecaller_bucketwise_allocation_loading = true;
            })
            .addCase(fetchTelecallerBucketWiseAllocation.fulfilled, (state, action) => {
                state.telecaller_bucketwise_allocation_loading = false;
                state.telecaller_bucketwise_allocation = action.payload;
            })
            .addCase(fetchTelecallerBucketWiseAllocation.rejected, (state, action) => {
                state.telecaller_bucketwise_allocation_loading = false;
                state.telecaller_bucketwise_allocation = {};
            })

            .addCase(fetchTelecallerBucketWiseStatus.pending, (state) => {
                state.telecaller_bucketwise_status_loading = true;
            })
            .addCase(fetchTelecallerBucketWiseStatus.fulfilled, (state, action) => {
                state.telecaller_bucketwise_status_loading = false;
                state.telecaller_bucketwise_status = action.payload;
            })
            .addCase(fetchTelecallerBucketWiseStatus.rejected, (state, action) => {
                state.telecaller_bucketwise_status_loading = false;
                state.telecaller_bucketwise_status = {};
            })

            .addCase(fetchTelecallerBankTeamleadOverview.pending, (state) => {
                state.telecaller_bank_teamlead_overview_loading = true;
            })
            .addCase(fetchTelecallerBankTeamleadOverview.fulfilled, (state, action) => {
                state.telecaller_bank_teamlead_overview_loading = false;
                state.telecaller_bank_teamlead_overview = action.payload;
            })
            .addCase(fetchTelecallerBankTeamleadOverview.rejected, (state, action) => {
                state.telecaller_bank_teamlead_overview_loading = false;
                state.telecaller_bank_teamlead_overview = {};
            })

            .addCase(fetchTelecallerBankreportStats.pending, (state) => {
                state.telecaller_bankreport_stats_loading = true;
            })
            .addCase(fetchTelecallerBankreportStats.fulfilled, (state, action) => {
                state.telecaller_bankreport_stats_loading = false;
                state.telecaller_bankreport_stats = action.payload;
            })
            .addCase(fetchTelecallerBankreportStats.rejected, (state, action) => {
                state.telecaller_bankreport_stats_loading = false;
                state.telecaller_bankreport_stats = {};
            })
    },
});

export default telecallerBankDashboard.reducer;
